import { responsiveFontSizes, createTheme } from "@mui/material/styles";

let theme = createTheme({
  palette: {
    primary: {
      main: "#00419E",
      light: "#0b63e0",
    },
    secondary: {
      main: "#D6EDF6",
    },
    text: {
      textColortheme: "#fff",
      gray: "#DCDCDC ",
      grayHeigh: "#595B62",
    },
    background: {
      basic: "#13141E",
      secondary: "#fff",
      darkBlue: " #131923",
      offWhite: "#F6F6F6",
    },
  },
  typography: {
    fontFamily: ['"Anton"', "Open Sans", "sans-serif"].join(","),

    h1: {
      fontSize: "30px",
      fontWeight: "700",
      fontFamily: "Open Sans",
    },
    h2: {
      fontSize: "12px",
      fontWeight: "400",
      fontFamily: "Open Sans",
    },
    h3: {
      fontSize: "16px",
      fontWeight: "400",
      fontFamily: "Open Sans",
    },
    h4: {
      fontSize: "18px",
      fontWeight: "600",
      fontFamily: "Open Sans",
      color: "rgba(18, 21, 32, 0.69)",
    },
    h5: {
      fontSize: "20px",
      fontWeight: "700",
      fontFamily: "Open Sans",
    },
    subtypo: {
      color: "#121520",
      fontFamily: "Open Sans",
      fontSize: "14px",
      fontWeight: "400",
    },
    subtypo2: {
      fontFamily: "Open Sans",
      fontSize: "14px",
      fontWeight: "700",
    },
    subtypo3: {
      fontFamily: "Open Sans",
      color: "#fff",
      fontSize: "14px",
      fontWeight: "400",
    },
    subtitle1: {
      fontSize: "18px",
      fontFamily: "Open Sans",
      background: "linear-gradient(231.13deg, #08A5CF 14.71%, #2FEF64 87.56%)",
      WebkitBackgroundClip: "text",
      WebkitTextFillColor: "transparent",
      backgroundClip: "text",
      textFillColor: "transparent",
    },
    subtitle2: {
      fontSize: "24px",
      fontFamily: "Open Sans",
      background: "linear-gradient(231.13deg, #08A5CF 14.71%, #2FEF64 87.56%)",
      WebkitBackgroundClip: "text",
      WebkitTextFillColor: "transparent",
      backgroundClip: "text",
      textFillColor: "transparent",
    },
    subtitle3: {
      fontSize: "36px",
      fontFamily: "Open Sans",
      background: "linear-gradient(231.13deg, #08A5CF 14.71%, #2FEF64 87.56%)",
      WebkitBackgroundClip: "text",
      WebkitTextFillColor: "transparent",
      backgroundClip: "text",
      textFillColor: "transparent",
    },
    body1: {
      fontSize: "18px",
      fontFamily: "Open Sans",
      color: "rgba(217, 217, 217, 0.69)",
    },
  },
  components: {
    MuiButton: {
      variants: [
        {
          props: { variant: "gradient" },
          style: {
            background:
              "linear-gradient(231.13deg, #08A5CF 14.71%, #2FEF64 87.56%)",
            color: "#fff",
            borderRadius: "10px",
            fontStyle: "normal",
            fontFamily: "Open Sans",
            fontWeight: "400",
            fontSize: "18px",

            "&:hover": {
              background:
                "linear-gradient(231.13deg, #08A5CF 14.71%, #2FEF64 87.56%)",
            },
          },
        },
        {
          props: { variant: "gradienttext" },
          style: {
            textTransform: "uppercase",
            background:
              "linear-gradient(231.13deg, #08A5CF 14.71%, #2FEF64 87.56%)",
            WebkitBackgroundClip: "text",
            WebkitTextFillColor: "transparent",
            backgroundClip: "text",
            textFillColor: "transparent",
            fontSize: "16px",
          },
        },
      ],
    },
  },
});

theme = responsiveFontSizes(theme);
export { theme };
